module.exports = __webpack_public_path__ + "img/account.6f5f623a.jpg";